"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var IconLoader = function IconLoader(props) {
  var size = props.size,
    rounded = props.rounded,
    className = props.className,
    id = props.id,
    style = props.style;
  var barLoaderClass = function barLoaderClass() {
    return (0, _classnames["default"])({
      'icon-loader': true,
      'icon-loader--small': (0, _lodash.isEqual)('small', size),
      'icon-loader--small-rounded': (0, _lodash.isEqual)('small', size) && rounded,
      'icon-loader--large': (0, _lodash.isEqual)('large', size),
      'icon-loader--large-rounded': (0, _lodash.isEqual)('large', size) && rounded,
      'icon-loader--rounded': rounded && (!(0, _lodash.isEqual)('large', size) || !(0, _lodash.isEqual)('small', size))
    }, className);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: id,
    style: style,
    className: barLoaderClass()
  });
};
IconLoader.propTypes = {
  /** id for reference */
  id: _propTypes["default"].string,
  /** className for reference */
  className: _propTypes["default"].string,
  /** string to have small, normal, or large icon loaders */
  size: _propTypes["default"].oneOf(['large', 'regular', 'small']),
  /** use if you want rounded corners */
  rounded: _propTypes["default"].bool,
  /** Override the inline-styles of the root element || Not Recommended */
  style: _propTypes["default"].object
};
IconLoader.defaultProps = {
  id: '',
  className: '',
  size: 'regular',
  rounded: false,
  style: {}
};
var _default = exports["default"] = IconLoader;